import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import 'what-input';

import { Permissions, ReportTypes } from '@cloud-wave/neon-common-lib';
import { PAGE_ROUTES } from '@cloud-wave/neon-common-lib/app';

import { useConfigContext } from 'lib/core/config';
import { useAuthContext } from 'lib/core/context/AuthProvider';

import LogStreamProvider from 'lib/common/contexts/LogStreamContext';
// contexts
import PermissionsContext from 'lib/common/contexts/PermissionsContext';

// components
import AuthorisedRoute from 'lib/common/components/AuthorisedRoute';
import Loader from 'lib/common/components/Loader';
import WithApiContexts from 'lib/common/components/atoms/WithApiContexts';

import { IsolatedLayout } from 'lib/common/layouts';

import { anyValidUser, supervisorOrAdmin } from '../userRoleCombinations';

const Users = lazy(() => import('../../pages/Users'));
const Report = lazy(() => import('../../pages/desktop/Report'));
const NotFound = lazy(() => import('lib/common/components/NotFound'));

function IsolatedRoutes() {
  const { user } = useAuthContext();
  const { config } = useConfigContext();

  return (
    <IsolatedLayout>
      <PermissionsContext config={config} user={user}>
        <LogStreamProvider>
          <Suspense fallback={<Loader centered />}>
            <Routes>
              <Route
                path={PAGE_ROUTES.REPORTS_PERFORMANCE_TODAY}
                element={
                  <AuthorisedRoute
                    allowedRoles={supervisorOrAdmin}
                    permissionType="tenant"
                    permission={Permissions.REPORTS_PERFORMANCE_TODAY}
                  >
                    <WithApiContexts
                      component={Report}
                      props={{ type: ReportTypes.PERFORMANCE_TODAY }}
                      user={user}
                      key={ReportTypes.PERFORMANCE_TODAY}
                    />
                  </AuthorisedRoute>
                }
              />
              <Route
                path={`${PAGE_ROUTES.USER_SETTINGS}/*`}
                element={
                  <AuthorisedRoute allowedRoles={supervisorOrAdmin}>
                    <WithApiContexts component={Users} user={user} key={PAGE_ROUTES.USER_SETTINGS} />
                  </AuthorisedRoute>
                }
              />
              <Route
                path={PAGE_ROUTES.REPORTS_ANALYTICS}
                element={
                  <AuthorisedRoute
                    allowedRoles={supervisorOrAdmin}
                    permissionType="tenant"
                    permission={Permissions.REPORTS_ANALYTICS}
                  >
                    <WithApiContexts
                      component={Report}
                      props={{ type: ReportTypes.ANALYTICS }}
                      user={user}
                      key={ReportTypes.ANALYTICS}
                    />
                  </AuthorisedRoute>
                }
              />
              <Route
                path={PAGE_ROUTES.REPORTS_WALLBOARD}
                element={
                  <AuthorisedRoute
                    permissionType="tenant"
                    permission={Permissions.REPORTS_WALLBOARD}
                    allowedRoles={anyValidUser}
                  >
                    <WithApiContexts
                      component={Report}
                      props={{ type: ReportTypes.WALLBOARD }}
                      user={user}
                      key={ReportTypes.WALLBOARD}
                    />
                  </AuthorisedRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </LogStreamProvider>
      </PermissionsContext>
    </IsolatedLayout>
  );
}

export default IsolatedRoutes;
